import { MdAdminPanelSettings, MdPriceChange } from 'react-icons/md';
import { AiFillProject, AiOutlineLineChart } from 'react-icons/ai';
import {
	FaBookMedical,
	FaHandHoldingUsd,
	FaHandHoldingHeart,
	FaHandHoldingMedical,
	FaHandHoldingWater,
	FaTruckLoading,
	FaUsers,
	FaListAlt,
	FaBoxes,
	FaMoneyBill,
	FaBell,
	FaTasks,
	FaShoppingBag,
	FaChartBar,
} from 'react-icons/fa';
import { BsFillFolderFill } from 'react-icons/bs';
import { IoNewspaperSharp } from 'react-icons/io5';
import { FaShippingFast } from 'react-icons/fa';
import { RiAdminFill } from 'react-icons/ri';
import { GiShakingHands } from 'react-icons/gi';

const defaultModules = [
	{
		label: 'Administrativo', // Un menú desplegable
		icon: <MdAdminPanelSettings />,
		isSubmenu: true,
		items: [
			// Los sub menús
			// {
			// 	name: 'Modulo de usuarios', // El nombre de este módulo en la bd
			// 	label: 'Usuarios y Permisos', // El nombre mostrado en el sidebar
			// 	icon: <RiAdminFill />, // El ícono mostrado, puede ser un componente de react-icons o cualquier otro
			// 	path: '/usersmodule', // La ruta a la que se redirige al hacer click en este item
			// },
			{
				name: 'Proveedores',
				label: 'Proveedores',
				icon: <FaTruckLoading />,
				path: '/suppliers',
			},
			// {
			// 	name: 'Modulo de usuarios',
			// 	label: 'Modulo de usuarios',
			// 	icon: <FaListAlt />,
			// 	path: '/usersmodule',
			// },
			{
				name: 'Modulos y Roles',
				label: 'Modulos y Roles',
				icon: <FaListAlt />,
				path: '/roles',
			},
			{
				name: 'Clientes',
				label: 'Clientes',
				icon: <GiShakingHands />,
				path: '/clients',
			},
			
			{
				name: 'Precios',
				label: 'Precios',
				icon: <MdPriceChange />,
				path: '/prices',
			},
			{
				name: 'Empleados',
				label: 'Empleados',
				icon: <FaUsers />,
				path: '/empleados',
			},
			{
				name: 'Cargos',
				label: 'Cargos',
				icon: <FaListAlt />,
				path: '/payroll-concepts',
			},
			{
				name: 'Materiales',
				label: 'Materiales',
				icon: <FaBoxes />,
				path: '/materials',
			},
			{
				name: 'Tipo de artículos y categorías',
				label: 'Tipo de artículos y categorías',
				icon: <FaBoxes />,
				path: '/articles-categories',
			},
		],
	},
	{
		label: 'Proveedor',
		icon: <AiFillProject />,
		isSubmenu: true,
		items: [
			{
				name: 'Gestión',
				label: 'Gestión',
				icon: <BsFillFolderFill />,
				path: '/providers',
			},
			{
				name: 'Skus',
				label: 'Skus',
				icon: <FaListAlt />,
				path: '/skus',
			},
			{
				name: 'Indicadores',
				label: 'Indicadores',
				icon:  <AiOutlineLineChart />,
				path: '/reception',
			},
			{
				name: 'Informes',
				label: 'Informes',
				icon:  <FaTasks />,
				path: '/report',
			},
			{
				name: 'Ordenes de despacho',
				label: 'Ordenes de despacho',
				icon:  <FaShippingFast />,
				path: '/dispatch',
			},
			{
				name: 'Ordenes de compras',
				label: 'Ordenes de compras',
				icon:  <FaShoppingBag />,
				path: '/purchases',
			},
			{
				name: 'Detalle inventario',
				label: 'Detalle de inventario',
				icon:  <FaChartBar />,
				path: '/provider-inventory-detail',
			},
			{
				name: 'Distribuci\u00f3n diaria',
				label: 'Reporte distribución diaria',
				icon:  <IoNewspaperSharp />,
				path: '/reports/daily-inventory-distribution',
			},
		],
	},
	{
		name: 'Dashboard',
		label: 'Dashboard',
		icon: <FaChartBar />,
		isSubmenu: false,
		path: '/dashboard'
	},
	{
		label: 'Proyectos',
		icon: <AiFillProject />,
		isSubmenu: true,
		items: [
			{
				name: 'Proyectos',
				label: 'En curso',
				icon: <BsFillFolderFill />,
				path: '/projects',
			},
			{
				name: 'Licitaciones',
				label: 'Licitaciones',
				icon: <IoNewspaperSharp />,
				path: '/tenders-page',
			},
			{
				name: 'Produccion',
				label: 'Costos de producción',
				icon: <FaMoneyBill />,
				path: '/production',
			},
		],
	},
	{
		label: 'Seguridad social',
		icon: <FaBookMedical />,
		isSubmenu: true,
		items: [
			{
				name: 'Pensiones',
				label: 'Pensiones',
				icon: <FaHandHoldingHeart />,
				path: '/pensions',
			},
			{
				name: 'Cesantias',
				label: 'Cesantías',
				icon: <FaHandHoldingUsd />,
				path: '/layoffs',
			},
			{
				name: 'EPS',
				label: 'EPS',
				icon: <FaHandHoldingMedical />,
				path: '/eps',
			},
			{
				name: 'ARL',
				label: 'ARL',
				icon: <FaHandHoldingWater />,
				path: '/arl',
			},
		],
	},
	{
		name: 'Notificaciones',
		label: 'Notificaciones',
		icon: <FaBell />,
		isSubmenu: false,
		path: '/notifications'
	},
];

export default defaultModules;
